import { api } from "../../gateways/unilabApi";

export async function getConnectionsList() {
  return await api.get(`connections/list`);
}
export async function postRemove(payload) {
  return await api.post(`connections/destroy`, payload);
}
export async function getConnectionsExportList() {
  return await api.get(`connections/listExport`);
}
export async function postupdateAddAllExport(payload) {
  return await api.post(`connections/updateAddAllExport`, payload);
}
export async function postCheckDelete(payload) {
  return await api.post(`connections/checkDelete`, payload);
}
export async function getExportModel() {
  return await api.get(`connections/exportModel`);
}